import { IProduct, IProject } from "~/integrations/firebase/collections";

export const getProjectProducts = (project: IProject, products: IProduct[]) => {
  return project.productIds.map(
    (id) => products.find((product) => product.id === id) ?? { id, isbn: null },
  );
};

// Matches the query against the product fields shown to users (title, author,
// ISBN, imprint, product form). Case-insensitive, partial. Shared between the
// table's global filter and the header count so both always agree.
export const productMatchesQuery = (product: IProduct, query: string) => {
  const trimmedQuery = query.trim().toLowerCase();
  if (!trimmedQuery) {
    return true;
  }

  const haystack = [
    product.title,
    product.author?.join(" "),
    product.isbn,
    product.imprints?.join(" "),
    product.productGroupDescription,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return haystack.includes(trimmedQuery);
};
